import * as React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { triggerBaixaLog, triggerBaixarScript, triggerCarregaListaExecucoes, triggerSolicitaExecucao, updateExecucoesAtributo } from "../ScriptManagerSlice";
import { Box, Button, CircularProgress, Grid, Link, Modal, ModalDialog, Stack, Table, Textarea, Typography } from '@mui/joy';
import { formatDateComHoras, formatDateJavaComHoras } from '../../helper/functions';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { displayGeneralDetail } from '../../helper/general-details/GeneralDetailSlice';
import { rpcPost } from '../../rpc/rpc_helper';

function ModalLog(props) {

    var data = props.data

    var dataToPrint = "sem logs";

    if (typeof (data) == "string") {
        // data = JSON.parse(data)
        dataToPrint = "Data broken - non JSON \n"
        dataToPrint += data
    }

    // console.log(data != null)
    // console.log(data.logs != null)

    if (data != null && data.logs != null) {
        dataToPrint = "";

        data.logs.forEach(d => {
            dataToPrint += d + "\n"
        })
    }

    return <Modal open={props.isOpen} onClose={props.close}>
        <ModalDialog
            aria-labelledby="basic-modal-dialog-title"
            aria-describedby="basic-modal-dialog-description"
            sx={{ width: 750 }}
        >
            <Typography id="basic-modal-dialog-title" component="h2">
                Logs
            </Typography>

            {props.baixando && "Baixando"}
            {!props.baixando && data != null &&
                <Stack spacing={1}>
                    <Typography> <b>ID:</b> {data.id}</Typography>
                    <Typography> <b>Path:</b> {data.path}</Typography>
                    <Typography> <b>Inicio:</b> {data.inicio}</Typography>
                    <Typography> <b>Término:</b> {data.termino}</Typography>
                    <Typography> <b>Sucesso:</b> {data.sucesso ? "T" : "F"}</Typography>
                    <Typography> <b>Tempo Execução:</b> {data.tempoExecucao}</Typography>
                    <Textarea minRows={20} value={dataToPrint} maxRows={20} ></Textarea>
                </Stack>}
        </ModalDialog>
    </Modal>
}

function ScriptExecManager() {
    let { scriptId } = useParams();

    var dispatch = useDispatch();
    var execucoes = useSelector((state) => state.scripts.execucoes)
    var url = useSelector((state) => state.rpc.servidorUrl)
    var token = useSelector((state) => state.auth.token)
    var loading = execucoes.carregando
    var lista = execucoes.lista
    var solicitando = execucoes.solicitando
    var isOpen = execucoes.modalOpen
    var logData = execucoes.logData

    var baixandoLog = execucoes.baixandoLog

    var openLog = (scriptId, execucaoId) => {
        dispatch(triggerBaixaLog({ scriptId, execucaoId }))
    }

    var [formExecute, setFormExecute] = React.useState({
        isOpen: false,
        executando: false,
        params: ""

    })

    var triggerExecutar = () => {
        // dispatch(triggerSolicitaExecucao(scriptId))
        setFormExecute({ ...formExecute, params: "", isOpen: true })


    }

    React.useEffect(() => {
        dispatch(triggerCarregaListaExecucoes(scriptId))
    }, []);

    const executar = async (params) => {
        setFormExecute({ ...formExecute, executando: true })

        var r = await rpcPost(url, token, null, {
            action: "SCRIPT_SOLICITAR_EXECUCAO_SCRIPT_RPC",
            runNow: true,
            payload: JSON.stringify({
                scriptId: scriptId,
                params: params
            })
        })

        if (r.status == 200) {
            setFormExecute({ ...formExecute, executando: false, isOpen: false })
            dispatch(triggerCarregaListaExecucoes(scriptId))
        } else {
            console.log(r)
        }
    }
    function ModalParam(props) {
        const textareaRef = React.useRef(null);
        const [localParams, setLocalParams] = React.useState(props.initialParams || ""); // Estado local para o textarea
    
        const handleChange = (event) => {
            setLocalParams(event.target.value); // Atualiza o estado local
        };
    
        const handleSolicitarExecucao = () => {
            props.onSubmit(localParams); // Envia o valor atual para o estado pai ou back-end
            props.close(); // Fecha o modal
        };
    
        React.useEffect(() => {
            textareaRef.current?.focus(); // Garante que o foco seja mantido
        }, []);
    
        return (
            <Modal open={props.isOpen} onClose={props.close}>
                <ModalDialog
                    aria-labelledby="basic-modal-dialog-title"
                    aria-describedby="basic-modal-dialog-description"
                    sx={{ width: 750 }}
                >
                    <Typography id="basic-modal-dialog-title" component="h2">
                        PARAMS
                    </Typography>
    
                    <Stack spacing={1}>
                        <Textarea
                            minRows={20}
                            maxRows={20}
                            ref={textareaRef}
                            value={localParams} // Usa o estado local
                            onChange={handleChange}
                        />
                        <Button color="danger" onClick={handleSolicitarExecucao}>
                            Solicitar Execução
                        </Button>
                    </Stack>
                </ModalDialog>
            </Modal>
        );
    }
    
    // function ModalParam(props) {
    //     const textareaRef = React.useRef(null);
    //     return <Modal open={props.isOpen} onClose={props.close}>
    //         <ModalDialog
    //             aria-labelledby="basic-modal-dialog-title"
    //             aria-describedby="basic-modal-dialog-description"
    //             sx={{ width: 750 }}
    //         >
    //             <Typography id="basic-modal-dialog-title" component="h2">
    //                 PARAMS
    //             </Typography>

    //             <Stack spacing={1}>
    //                 <Textarea minRows={20} maxRows={20}
    //                 ref={textareaRef}
    //                     onChange={(a) => {
    //                         setFormExecute((prev) => ({ ...prev, params: a.target.value }))
    //                         textareaRef.current.focus();
    //                     }}
    //                     value={formExecute.params} ></Textarea>
    //                 <Button color="danger" onClick={() => {
    //                     setFormExecute({ ...formExecute, isOpen: false })
    //                     executar()
    //                 }}>Solicitar Execução</Button>
    //             </Stack>
    //         </ModalDialog>
    //     </Modal>
    // }

    return <Grid container sx={{ padding: "10px" }}>
        <ModalParam isOpen={formExecute.isOpen} 
        close={() => setFormExecute({ ...formExecute, isOpen: false })}
        onSubmit={(params) => {
            setFormExecute((prev) => ({ ...prev, params })); // Atualiza o estado global com os novos params
            executar(params); // Executa a lógica ao enviar
        }} />
        <ModalLog isOpen={isOpen} close={() => {

            dispatch(updateExecucoesAtributo({
                campo: "modalOpen",
                value: false
            }))

        }} data={logData} baixando={baixandoLog} />
        <Grid xs={12}>
            <Stack spacing={2}>
                {loading && <>
                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                        <Stack direction={"row"} spacing={2}>
                            <Typography>
                                Carregando
                            </Typography>
                            <CircularProgress size="sm" />
                        </Stack>
                    </Box>
                </>}
                {!loading &&
                    <Box>
                        <Stack direction={"row"} spacing={2}>
                            <Button color='danger' onClick={triggerExecutar} disabled={solicitando}>{solicitando ? "Solicitando..." : "Solicitar execução"}</Button>

                            <Button color='primary' onClick={() => dispatch(triggerCarregaListaExecucoes(scriptId))} disabled={solicitando}>Atualizar</Button>

                            <Button color='primary' onClick={() => dispatch(triggerBaixarScript(scriptId))} disabled={solicitando}>Baixar script</Button>
                        </Stack>
                    </Box>}
                {!loading &&
                    <Table size="small" aria-label="striped table" stripe={"odd"}>
                        <thead>
                            <tr>
                                <th style={{ width: "5%", textAlign: "left" }}>ID</th>
                                <th style={{ width: "15%", textAlign: "left" }}>Data</th>
                                <th style={{ width: "10%", textAlign: "left" }}>Status</th>
                                <th style={{ width: "8%", textAlign: "left" }}>Temp</th>
                                <th style={{ width: "5%", textAlign: "left" }}>Suc.</th>
                                <th style={{ textAlign: "left" }}>Nota</th>
                                <th style={{ width: "5%", textAlign: "left" }}>LOG</th>
                            </tr>
                        </thead>
                        <tbody>
                            {lista.map(l =>
                                <tr key={l.execucaoId}>
                                    <td> <Link onClick={() => dispatch(displayGeneralDetail(l.execucaoId))
                                    }>{"ID"}</Link></td>
                                    <td>{formatDateJavaComHoras(l.dataSolicitacao)}</td>
                                    <td>{l.status}</td>
                                    <td>{l.tempoExecucao}</td>
                                    <td>{l.sucesso ?
                                        <CheckCircleOutlineIcon style={{ color: "green" }} /> :
                                        <ErrorOutlineIcon style={{ color: "red" }} />}</td>
                                    <td>{l.nota}</td>
                                    <td>
                                        <Link onClick={() => openLog(scriptId, l.execucaoId)}>LOG</Link>
                                    </td>
                                </tr>
                            )}

                        </tbody>
                    </Table>}
            </Stack>
        </Grid>
    </Grid>

}

export default ScriptExecManager